var map = {
	"./ActiveUserStory.png": 564,
	"./EstimateUserStories.png": 8888,
	"./InviteYourTeam.png": 9113,
	"./LeaveButton.png": 2755,
	"./SetUpSession.png": 2369,
	"./Timer.png": 5577,
	"./azuredevops.png": 2476,
	"./bull.png": 6007,
	"./camel.png": 4304,
	"./cat.png": 2970,
	"./cow.png": 7263,
	"./crown.png": 1743,
	"./diveniLogo.png": 6548,
	"./dog.png": 5156,
	"./duck.png": 919,
	"./elephant.png": 9779,
	"./fish.png": 7366,
	"./giraffe.png": 6834,
	"./github.png": 9449,
	"./gitlab.png": 6705,
	"./goose.png": 4231,
	"./horse.png": 8509,
	"./img/diveni-background.png": 2112,
	"./jiracloud.png": 1993,
	"./jiraserver.png": 5837,
	"./lion.png": 9090,
	"./logo.png": 3153,
	"./monkey.png": 3703,
	"./mouse.png": 8339,
	"./pigeon.png": 714,
	"./preparePage/Fibonacci-DarkMode.png": 5467,
	"./preparePage/Fibonacci-LightMode.png": 9265,
	"./preparePage/Hour-DarkMode.png": 5941,
	"./preparePage/Hour-LightMode.png": 7339,
	"./preparePage/Mode1.png": 5813,
	"./preparePage/Mode2.png": 5438,
	"./preparePage/Mode3.png": 1223,
	"./preparePage/Numbers-DarkMode.png": 405,
	"./preparePage/Numbers-LightMode.png": 987,
	"./preparePage/OwnSet-DarkMode.png": 6735,
	"./preparePage/OwnSet-LightMode.png": 5373,
	"./preparePage/P1.png": 14,
	"./preparePage/P1D.png": 7112,
	"./preparePage/P2.png": 8165,
	"./preparePage/P2D.png": 2725,
	"./preparePage/P3.png": 8748,
	"./preparePage/P3D.png": 1458,
	"./preparePage/P4.png": 2355,
	"./preparePage/P4D.png": 1967,
	"./preparePage/TShirt-DarkMode.png": 4003,
	"./preparePage/TShirt-LightMode.png": 8953,
	"./rabbit.png": 1200,
	"./tiger.png": 7735,
	"./turtle.png": 2242,
	"./wolf.png": 1700,
	"./zebra.png": 9154
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;